export default __webpack_public_path__ + "static/media/Pelita Grande Std-Bold.a4f4447f.otf";